import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { EmailForm, Modal, ModalSuccessMessage } from "../../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { RequestSyllabusModalWrapper } from "./styles";

const RequestSyllabusModal = ({
	show,
	onClose,
	context,
	globalDomain,
	portalId,
	formId,
	variation_id,
	onSyllabusRequested,
}) => {
	// States
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);
	const { apiBaseUrl, workshop_id, slug, dripTagPrefix } = context;
	const globalDomainEnabled = globalDomain;

	const apiEndPoint = `${apiBaseUrl}/learning-paths/interested/`;

	useEffect(() => {
		if (!globalDomainEnabled) {
			if (typeof window !== "undefined") {
				const script = document.createElement("script");
				script.src = "https://js.hsforms.net/forms/v2.js";
				document.body.appendChild(script);
			}
		}
	}, []);

	if (show) {
		if (!globalDomainEnabled) {
			if (window.hbspt) {
				window.hbspt.forms.create({
					portalId: portalId,
					formId: formId,
					target: "#hubspotFormSyllabus",
				});
			}
		}
	}

	return (
		<RequestSyllabusModalWrapper>
			<Modal show={show} disableBackdropClick={true} onClose={onClose}>
				<div className="modalBody">
					{globalDomainEnabled ? (
						<div>
							{success ? (
								<ModalSuccessMessage />
							) : (
								<div className="modalContent">
									<div className="modalHeader">
										<div className="imageWrapper">
											<CloudinaryImage
												lazyload
												url="https://res.cloudinary.com/springboard-images/image/upload/v1/homepage-assets/icons/icon-email-waitlist.png"
												sizes={{
													default: {
														height: 60,
													},
												}}
											/>
										</div>
										<h3>Get the detailed syllabus delivered to your email.</h3>
									</div>
									<div className="modalCTA">
										<EmailForm
											actionOnSuccess="CALLBACK"
											formData={{
												workshop_id,
												syllabus: 1,
												js_disabled: "yes",
												variation_id,
												drip_tag_prefix: dripTagPrefix,
											}}
											apiEndPoint={apiEndPoint}
											buttonText={error ? "Try again" : "Get syllabus"}
											className="emailForm"
											callbackOnSuccess={() => {
												onSyllabusRequested();
												setSuccess(true);
											}}
											callbackOnError={() => setError(true)}
										/>
									</div>
								</div>
							)}
						</div>
					) : (
						<div id="hubspotFormSyllabus"></div>
					)}
				</div>
			</Modal>
		</RequestSyllabusModalWrapper>
	);
};

RequestSyllabusModal.defaultProps = {
	show: false,
	onClose: () => {},
};

RequestSyllabusModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
};

export default RequestSyllabusModal;
